import { ChangeDetectionStrategy, Component, input, output, signal } from '@angular/core';

@Component({
  selector: 'app-file-dropzone',
  templateUrl: './file-dropzone.component.html',
  styleUrl: './file-dropzone.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FileDropzoneComponent {
  readonly inputId = input<string | undefined>(undefined);
  readonly iconClass = input<string>('bi-cloud-upload');
  readonly primaryText = input<string>('Drag & drop file here');
  readonly secondaryText = input<string>('');
  readonly multiple = input<boolean>(true);

  readonly filesSelected = output<File[]>();

  readonly isDragOver = signal(false);

  onDragOver(event: DragEvent): void {
    event.preventDefault();
    this.isDragOver.set(true);
  }

  onDragLeave(event: DragEvent): void {
    event.preventDefault();
    this.isDragOver.set(false);
  }

  onDrop(event: DragEvent): void {
    event.preventDefault();
    this.isDragOver.set(false);
    this.emitFiles(event.dataTransfer?.files);
  }

  onBrowseFiles(event: Event): void {
    const input = event.target as HTMLInputElement | null;
    this.emitFiles(input?.files);
    if (input) input.value = '';
  }

  private emitFiles(fileList: FileList | null | undefined): void {
    if (!fileList || fileList.length === 0) return;
    this.filesSelected.emit(Array.from(fileList));
  }
}
